/**
 * String must format in
 *
 * dd/mm/yyyy hh:mm
 */
export function stringToDate(str: string): Date {
  // TODO: Validate date
  const [dateValues, timeValues] = str.split(' ')

  const [day, month, year] = dateValues.split('/')
  const [hours, minutes] = timeValues.split(':')

  const date = new Date(+year, +month - 1, +day, +hours, +minutes, 0)

  return date
}
